"use strict";

// Based on: https://github.com/lodash/lodash/blob/6018350ac10d5ce6a5b7db625140b82aeab804df/.internal/unicodeSize.js
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.dot-all.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.sticky.js");
require("core-js/modules/es.regexp.to-string.js");
module.exports = function () {
  // Used to compose unicode character classes.
  var astralRange = "\\ud800-\\udfff";
  var comboMarksRange = "\\u0300-\\u036f";
  var comboHalfMarksRange = "\\ufe20-\\ufe2f";
  var comboSymbolsRange = "\\u20d0-\\u20ff";
  var comboMarksExtendedRange = "\\u1ab0-\\u1aff";
  var comboMarksSupplementRange = "\\u1dc0-\\u1dff";
  var comboRange = comboMarksRange + comboHalfMarksRange + comboSymbolsRange + comboMarksExtendedRange + comboMarksSupplementRange;
  var varRange = "\\ufe0e\\ufe0f";
  var familyRange = "\\uD83D\\uDC69\\uD83C\\uDFFB\\u200D\\uD83C\\uDF93";

  // Used to compose unicode capture groups.
  var astral = "[".concat(astralRange, "]");
  var combo = "[".concat(comboRange, "]");
  var fitz = "\\ud83c[\\udffb-\\udfff]";
  var modifier = "(?:".concat(combo, "|").concat(fitz, ")");
  var nonAstral = "[^".concat(astralRange, "]");
  var regional = "(?:\\uD83C[\\uDDE6-\\uDDFF]){2}";
  var surrogatePair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
  var zwj = "\\u200d";
  var blackFlag = "(?:\\ud83c\\udff4\\udb40\\udc67\\udb40\\udc62\\udb40(?:\\udc65|\\udc73|\\udc77)\\udb40(?:\\udc6e|\\udc63|\\udc6c)\\udb40(?:\\udc67|\\udc74|\\udc73)\\udb40\\udc7f)";
  var family = "[".concat(familyRange, "]");

  // Used to compose unicode regexes.
  var optModifier = "".concat(modifier, "?");
  var optVar = "[".concat(varRange, "]?");
  var optJoin = "(?:".concat(zwj, "(?:").concat([nonAstral, regional, surrogatePair].join("|"), ")").concat(optVar + optModifier, ")*");
  var seq = optVar + optModifier + optJoin;
  var nonAstralCombo = "".concat(nonAstral).concat(combo, "?");
  var symbol = "(?:".concat([nonAstralCombo, combo, regional, surrogatePair, astral, family].join("|"), ")");

  // Used to match [String symbols](https://mathiasbynens.be/notes/javascript-unicode).
  return new RegExp("".concat(blackFlag, "|").concat(fitz, "(?=").concat(fitz, ")|").concat(symbol + seq), "g");
};